import {useContext} from "react";
import {AgoraContext} from '../context/AgoraContext';

export const useRTMClient = () => {
    const {rtm} = useContext(AgoraContext);
    return rtm;
}
